import { render, staticRenderFns } from "./ZonesFormPriority.vue?vue&type=template&id=fbcd5d6c&scoped=true"
import script from "./ZonesFormPriority.vue?vue&type=script&lang=js"
export * from "./ZonesFormPriority.vue?vue&type=script&lang=js"
import style0 from "./ZonesFormPriority.vue?vue&type=style&index=0&id=fbcd5d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcd5d6c",
  null
  
)

export default component.exports